import { Box, Button, Typography, useTheme } from "@mui/material";
import Error from "~components/Templates/Error";

type Props = {
  onRetry: () => void;
};

const PermissionsLoadError = ({ onRetry }: Props) => {
  const theme: any = useTheme();

  return (
    <Error isSigned={true}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Typography
          variant="body1"
          component="span"
          sx={{ color: theme.palette.common.white }}
        >
          não foi possível carregar suas permissões.
        </Typography>
        <Button variant="contained" onClick={onRetry}>
          tentar novamente
        </Button>
      </Box>
    </Error>
  );
};

export default PermissionsLoadError;
